import React from 'react';

interface TeamHeaderProps {
  team: string;
  color: 'blue' | 'red';
}

const TeamHeader: React.FC<TeamHeaderProps> = ({ team, color }) => {
  return (
    <div className={`text-${color === 'blue' ? 'right' : 'left'}`}>
      <h2 className={`text-3xl font-bold text-${color}-600`}>{team}</h2>
      <p className="text-lg text-gray-500">Statistics</p>
    </div>
  );
};

export default TeamHeader;